module.exports = __webpack_public_path__ + "static/media/people.93a6e0d6.svg";